.button {
  width: 100%;
  display: block;
}

.buttonWrapper {
  border-radius: 48px;
  overflow: hidden;
  width: 100%;
  position: relative;
}

.customBtn {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  gap: 10px;
  pointer-events: none;
  z-index: 10;

  p {
    color: #FFF;
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.088px;
  }

  img {
    width: 58.5px;
  }
}

.title {
  margin: 20px 0;
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
}

.error {
  bottom: -1px;
  left: 0;
  font-size: 14px;
  line-height: 16px;
  color: #f76060;
  margin-top: 5px;
}